import { useTranslation } from 'react-i18next'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import swalAlert from '../../../utils/helpers/swalAlert'
import { SpainFuelStationsService } from '../../../services/spain-fuel-stations/spainFuelStations.service'
import useAccess from '../../../utils/hooks/useAccess'
import { FavoritesFuelStationsService } from '../../../services/favorites-fuel-stations/favoritesFuelStations.service'
import { GROUPS, MODULES } from '../../../utils/constants/roles'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import DataTableComp from '../../../components/common/data-table/DataTableComp'
import FavoriteButton from '../../../components/common/buttons/FavoriteButton'
import { bodyCurrencyInput } from '../../../components/common/data-table/column-types/ColumnTypes'
import './fuelStationsSpain.scss'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import { fuelStationsMenu } from '../../../utils/constants/navlinks-Menu'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'
import AppButton from '../../../component/common/AppButton.tsx'

const FuelStationsSpain = () => {
  const { formatMessage: msg } = useIntl()
  const { t } = useTranslation()
  const { canAdd, canEdit } = useAccess()

  const dataFacade = useHandlerBasicActions({
    getAll: SpainFuelStationsService.getAll,
    sortFieldInitial: 'addressInfo.province',
    rowsPerPageInitial: 100,
  })

  const updateFuelStationsSpain = async () => {
    const swal = swalAlert.loadinng(msg({ id: 'swal.title.loading' }))
    const resp = await SpainFuelStationsService.updateFuelStationSpain()
    if (resp) {
      dataFacade.reload()
      swal.close()
    }
  }

  const handleFavorite = async (data) => {
    let response = null
    if (!data?.isFavorite) {
      response = await FavoritesFuelStationsService.addFavorite({
        _id: data._id,
      })
    } else {
      response = await FavoritesFuelStationsService.removeFavorite(data._id)
    }
    if (response) dataFacade.reload()
  }

  const buttonFavorite = (rowData) => (
    <FavoriteButton
      isFavorite={rowData.isFavorite}
      onclick={() => handleFavorite(rowData)}
    />
  )

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const headerOptions = {
    // title: msg({ id: 'fuels.spain' }),
    // handlerHeaderActions: {
    //   secondaryButton:
    //     canEdit(MODULES.FUELSTATIONS, GROUPS.FUELSTATIONS) &&
    //     updateFuelStationsSpain,
    //   secondaryButtonText: 'button.replay.fuelStations',
    //   secondaryButtonIcon: 'pi-sync',
    // },
    searchOptions: dataFacade?.searchOptions,
  }

  const dataTable = (
    <DataTableComp
      loading={dataFacade?.loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        className: 'table-with-menu',
        value: dataFacade?.data?.resp,
        size: 'small',
        ...dataFacade?.sortOptions,
      }}
      columns={[
        <Column field="label" header={msg({ id: 'sign' })} sortable />,
        <Column field="id" header={msg({ id: 'idMinetur' })} sortable />,
        <Column
          field="addressInfo.province"
          header={msg({ id: 'province' })}
          sortable
        />,
        <Column
          field="addressInfo.locality"
          header={msg({ id: 'locality' })}
          sortable
        />,
        <Column field="addressInfo.address" header={msg({ id: 'address' })} />,
        <Column
          field="prices.GOA"
          header="GOA"
          body={(rowData) => bodyCurrencyInput(rowData?.prices?.GOA)}
        />,
        <Column
          field="prices.GOAPLUS"
          header="GOAPLUS"
          body={(rowData) => bodyCurrencyInput(rowData?.prices?.GOAPLUS)}
        />,
        <Column
          field="prices.G95"
          header="G95"
          body={(rowData) => bodyCurrencyInput(rowData?.prices?.G95)}
        />,
        canAdd(MODULES.FUELSTATIONS, GROUPS.FAVORITE) && (
          <Column
            body={buttonFavorite}
            className="row-delete"
            exportable={false}
          />
        ),
      ]}
    />
  )

  return (
    <AppSection
      /* refactor this */
      header={<AppTabMenu options={fuelStationsMenu} />}
      subheader={
        <AppToolbar
          leftSection={t('fuels.spain')}
          rightSection={[
            <AppButton
              preset="synch"
              disabled={!canEdit(MODULES.FUELSTATIONS, GROUPS.FUELSTATIONS)}
              onClick={
                canEdit(MODULES.FUELSTATIONS, GROUPS.FUELSTATIONS) &&
                updateFuelStationsSpain
              }
            />,
          ]}
        />
      }
      dataFacade={dataFacade}
      headerOptions={headerOptions}
    >
      {dataTable}
    </AppSection>
  )
}

export default FuelStationsSpain
